import { PropsWithChildren } from "react";

export const RootProviders = ({ children }: PropsWithChildren) => children;
